import { apiClient, tokenStorage } from "./httpClient";
import { unwrapEnvelope } from "./response";

export const authApi = {
  async login(credentials) {
    const response = await apiClient.post("/auth/login", credentials);
    const data = unwrapEnvelope(response.data, {});

    tokenStorage.setSession({
      accessToken: data.accessToken || data.access_token,
      refreshToken: data.refreshToken || data.refresh_token,
      user: data.user || data
    });

    return data;
  },

  async signup(payload) {
    const response = await apiClient.post("/auth/signup", payload);
    return unwrapEnvelope(response.data, null);
  },

  async logout() {
    const refreshToken = tokenStorage.getRefreshToken();

    if (refreshToken) {
      await apiClient.post("/auth/logout", { refreshToken });
    }

    tokenStorage.clearSession();
    tokenStorage.clearImpersonationOrigin();
  },

  async refresh(refreshToken = tokenStorage.getRefreshToken()) {
    const response = await apiClient.post("/auth/refresh", { refreshToken });
    return unwrapEnvelope(response.data, {});
  },

  async validateAccessToken(token) {
    const response = await apiClient.get(`/auth/access/${token}`);
    return unwrapEnvelope(response.data, null);
  },

  async redeemAccessToken(payload) {
    const response = await apiClient.post("/auth/access/redeem", payload);
    return unwrapEnvelope(response.data, null);
  }
};
